import { NetworkError } from '@/utils/notification'

/**
 * @description
 *    Uses fetch to post some data to the platform backend with the endpoint. It then unpacks the resulting json
 * @param endpoint
 *    The endpoint needed to be fetched
 * @param data
 *    The post body in a normal js object form
 * @param method
 *    The post method used (can be changed to PUT)
 */
// eslint-disable-next-line func-names
export default async function (endpoint, data = {}, method = 'POST') {
  try {
    const res = await fetch(endpoint, {
      method,
      mode: 'cors',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content'),
      },
      body: JSON.stringify(data),
    })

    return await res.json()
  } catch (e) {
    new NetworkError({ ex: e }).dispatch()
    return { error: true }
  }
}
